import React from 'react'
import { FormattedMessage } from 'react-intl'

const OrderBreadcrumb = ({
  match: {
    params: { address }
  }
}) => <FormattedMessage id={`Breadcrumbs.edit.${address}`} />

export default OrderBreadcrumb



// WEBPACK FOOTER //
// ./src/components/Routes/components/EditAddressBreadcrumb/index.js